import { Component, OnInit , AfterViewInit ,Renderer} from '@angular/core';
import {FormGroup,Validators,FormBuilder} from '@angular/forms';
import {DataService} from '../data.service';
import {PasswordValidation} from '../password-validation';
import {Router} from '@angular/router';
import {LoginComponent} from '../login/login.component';
import {DatePipe} from '@angular/common';
// import {IMyDpOptions, IMyDateModel} from 'angular4-datepicker/src/my-date-picker/interfaces';
import {HomeComponent} from '../home/home.component';




declare var $:any;

@Component({
  selector: 'app-sign-up-steps',
  templateUrl: './sign-up-steps.component.html',
  styleUrls: ['./sign-up-steps.component.css']
})
export class SignUpStepsComponent implements OnInit , AfterViewInit{
  step:number=2;
  userBackground:FormGroup;
  userEducation:FormGroup;
  userCommunity:FormGroup;
  userName:string="";
  userTypeId:number=-1;
  themeData:any[]=[];
  allThemes:any[]=[];
  selectedThemes:any[]=[];
  years:any[]=[];
  countThemes:number=0;
  isDeselect:boolean=false;
  positionClass:boolean=false;
  userRole:string='';
  organisation:string='';
  department:string='';
  planId:number=-1;
  isNext:boolean=false;
  myOptions={};
  companyId:number=-1;


  // public myDatePickerOptions: IMyDpOptions = {
  //      // other options...
  //      dateFormat: 'dd.mm.yyyy',
  //  };
  public myPlace: string = 'DOB';
  constructor(private renderer:Renderer,
    private service:DataService,
    private fb:FormBuilder,
    private fb2:FormBuilder,
    private fb3:FormBuilder,
    private router:Router,
    private login:LoginComponent,
    private home:HomeComponent


  ) {

    this.userBackground=this.fb.group({
      "work":[""],
      "industry":[""],
      "exp":[""]
    })

    this.userEducation=this.fb2.group({
      "education":[""],
      "interest":[""]
    })

    this.userCommunity=this.fb3.group({
      "year":["",Validators.required],
      "gender":[""]
    })
    this.myPlace = 'DOB';
    this.changePlaceholder();
    this.userRole=sessionStorage.getItem('UserRole')==null ? '' : sessionStorage.getItem('UserRole');
      this.organisation=sessionStorage.getItem('Company')==null ? '' : sessionStorage.getItem('Company');
        this.department=sessionStorage.getItem('Department')==null||sessionStorage.getItem('Department')=='' ? '' : sessionStorage.getItem('Department')
      this.userBackground.patchValue({
        'work':this.userRole,
        'industry':this.organisation,
        'exp':this.department
      })


   }

   changePlaceholder() {
        this.myPlace = 'DOB';
    }

  ngOnInit() {
    this.companyId=sessionStorage.getItem("companyId")==null ? -1 : parseInt(sessionStorage.getItem("companyId"));
    if(localStorage.getItem("UserName")!=null){
      this.userName=localStorage.getItem("UserName");
    }
    this.goToStep(2);
    this.getAllThemes();
    this.service.watchStorage().subscribe(()=>{
       // console.log("worked");
        this.userRole=sessionStorage.getItem('UserRole')==null ? '' : sessionStorage.getItem('UserRole');
          this.organisation=sessionStorage.getItem('Company')==null ? '' : sessionStorage.getItem('Company');
          this.department=sessionStorage.getItem('Department')==null||sessionStorage.getItem('Department')=='' ? '' : sessionStorage.getItem('Department')
          this.userBackground.patchValue({
            'work':this.userRole,
            'industry':this.organisation,
            'exp':this.department
          })
    })
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    this.myOptions={
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "d-m-Y",
      maxDate:"today",
    }
    sessionStorage.setItem('options',JSON.stringify(this.myOptions));
    this.service.storageSub.next('change');
  }

  ngAfterViewInit(){

    $(document).ready(function(){
      $("span.form-control").css('display','none');

    });


    // $('.cd-primary-nav-trigger').click(function(){
    //   if($('.cd-primary-nav').hasClass('is-visible')){
    //
    //     $('app-sign-up-steps').css('filter','blur(5px)');
    //   } else {
    //     $('app-sign-up-steps').css('filter','blur(0px)');
    //   }
    // })
      $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');

  }

  goToStep(pvarChoice){
    this.step=pvarChoice;
  }
  goToNextStep(pvarChoice){
    if(this.step==2){
      if(this.selectedThemes.length==0){
        // this.service.alert("Please select atleast 1 theme to proceed further","error");
        return false;
      }
      if(this.selectedThemes.length==0){
        // this.service.alert("Please select atleast 1 theme to proceed further","error");
        return false;
      }
      if(this.selectedThemes.length>3){
        this.service.alert("You can only select atmost 3 themes","error");
        return false;
      }
    }

    if(this.step==3){
      if(!this.userBackground.controls['work'].valid){
        this.service.alert("Please enter your work details","error");
        return false;
      }
      if(!this.userBackground.controls['industry'].valid){
        this.service.alert("Please enter your industry","error");
        return false;
      }
      if(!this.userBackground.controls['exp'].valid){
        this.service.alert("Please select your exp level","error");
        return false;
      }
    }


    if(pvarChoice < 5){
      this.goToStep(pvarChoice+1);
    }

  }

  goToPrevStep(pvarChoice){
    if(pvarChoice > 2){
      this.goToStep(pvarChoice-1);
    }

  }







  getAllThemes(){
    this.service.GetAllThemes({'CompanyId':this.companyId})
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){
          this.themeData=result['ThemeData'];
          this.createThemeObj();
        } else {
          this.service.alert(result['Message'],'error');
        }
      },
      (error)=>{
       // console.log(error);
      }
    )
  }

  error1:boolean = false;
  themeOver(checked){
    if(checked){
      return false;
    }
    this.isDeselect = false;
   // console.log(this.selectedThemes.length);
    if(this.selectedThemes.length < 3){
      this.error1 = true;
      //this.isDeselect = true;
    }
    else{
      this.error1 = false;
      this.isDeselect = true;
    }
  }

  selectThemes(id,checked){
    this.selectedThemes=this.allThemes.filter(theme=>theme.checked==true);
    if(this.selectedThemes.length<3){
     // console.log("before checking length is "+(this.selectedThemes.length));
      for(var i=0;i<this.allThemes.length;i++){
        if(id==this.allThemes[i]['id']){
          this.allThemes[i]['checked']=!checked;
        }
      }
      this.selectedThemes=this.allThemes.filter(theme=>theme.checked==true);
     // console.log("after checking length is "+this.selectedThemes.length);
      this.error1 = this.selectedThemes.length == 3 ? false : true;
     // console.log(this.allThemes);
      this.isDeselect=false;
     // console.log(this.selectedThemes);
      if(this.selectedThemes.length>3){
        this.service.alert("You can only select atmost 3 themes","error");
      }
      if(this.selectedThemes.length==0){
        // this.service.alert("Please select atleast 1 theme to proceed further","error");
      }
    } else {

      this.selectedThemes=this.allThemes.filter(theme=>theme.checked==true);

     // console.log("before checking length is "+(this.selectedThemes.length));

      for(var i=0;i<this.allThemes.length;i++){
        if(id==this.allThemes[i]['id']){
          this.isDeselect=!checked;
          this.allThemes[i]['checked']=false;
        }


      }

      this.selectedThemes=this.allThemes.filter(theme=>theme.checked==true);
     // console.log("after checking length is "+this.selectedThemes.length);
     // console.log(this.allThemes);

     // console.log(this.selectedThemes);
      if(this.selectedThemes.length>3){
        this.service.alert("You can only select atmost 3 themes","error");
      }
      if(this.selectedThemes.length==0){
        // this.service.alert("Please select atleast 1 theme to proceed further","error");
      }
    }


  }

  createThemeObj(){
    let myObj={};
    for(var i=0;i<this.themeData.length;i++){
      myObj={};
      myObj['id']=this.themeData[i]['ThemeId'];
      myObj['name']=this.themeData[i]['Name'];
      myObj['checked']=false;
      this.allThemes.push(myObj);
    }
   // console.log(this.allThemes);
  }


  addUserDetails(){
      var myarray=[];
      for(var i=0;i<this.selectedThemes.length;i++){
        myarray.push(this.selectedThemes[i]['id']);
      }

      const inputJson={
      	// "BornYear":this.userCommunity.value['year']['formatted'],
      	// "Career":this.userBackground.value['work'],
      	// "Education":this.userEducation.value['education'],
      	// "Experince":this.userBackground.value['exp'],
      	// "Gender":this.userCommunity.value['gender'],
      	// "Industary":this.userBackground.value['industry'],
      	// "Major":this.userEducation.value['interest'],
      	// "ThemeId":myarray,
      	// "UserId":parseInt(localStorage.getItem("UserId")),
        "BornYear": this.userCommunity.value['year'] ? this.transformDate(this.userCommunity.value['year']) : '',
      	"DepartMent":this.userBackground.value['exp'],
      	"Designation": this.userBackground.value['work'],
      	"Gender":this.userCommunity.value['gender'],
      	"Organization":this.userBackground.value['industry'],
      	"ThemeId":myarray,
      	"UserId":parseInt(localStorage.getItem("UserId")),
      }
     // console.log(inputJson);
      this.service.AddUserDetails(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){

            if(sessionStorage.getItem('SocialUser')!=null){
              let socialuser=JSON.parse(sessionStorage.getItem('SocialUser'))
                this.login.signUpSocialUser(socialuser);
            } else {

              this.login.loginUser(this.login.userForm,true);
            }
            setTimeout(()=>{
                this.router.navigate(['']);
            },2000)

          } else {
            this.service.alert(result['Message'],"error")
          }

        },
        (error)=>{
         // console.log(error);
        }
      )
    }

    transformDate(value){
    var b=value.split('-')
    var d= new Date(b[2],b[1]-1,b[0])
     var datePipe = new DatePipe("en-US");
     value = datePipe.transform(d, 'M/dd/yyyy');
     return value;
   }

   transformDateForFlatpickr(value){
    var datePipe = new DatePipe("en-US");
    value = datePipe.transform(value, 'yyyy-M-dd');
    return value;
  }


   showActiveModule(pvarId){
     this.home.showActiveModule(pvarId);
   }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/sign-up-steps/sign-up-steps.component.ts